import { useNavigate } from "react-router-dom";
import "../css/CategoryGrid.css";
import { useEffect, useState } from "react";
import { supabase } from "../lib/supabaseClient.ts";


const CategoryGridweb = () => {

    const [categories, setCategories] = useState([]);
    const navigate = useNavigate();
    
    useEffect(() => {
        async function fetchCategories() {
            const { data, error } = await supabase
                .from("categories")
                .select("*")
                .gte("id", 80)
                .lte("id", 87)
                .order("id");

            if (error) {
                console.error("Error fetching categories:", error);
            } else {
                setCategories(data);
            }
        }

        fetchCategories();
    }, []);

    // Function to get public URL from storage path
    const getImageUrl = (path) => {
        return supabase.storage
            .from("animalia")
            .getPublicUrl(path)
            .publicURL;
    };
    return (
        
        <div className="grid-wrapper">
            {categories.map((category) => (
                <div
                    key={category.id}
                    className="card"
                    style={{ backgroundImage: `url(${category.image})` }}
                >
                
                    <div className="card-overlay"           onClick={() => {
      navigate(`/category/${category.id}/${encodeURIComponent(category.name)}`);
}}>
                        <p className="card-title">{category.name}</p>
                            <img src="../figmaAssets/btn.png" alt="Voir plus" className="voir-plus-img" />
                            <span className="voir-plus-text">Voir plus</span>

                    </div>
                </div>
            ))}
        </div>
    );
};

export default CategoryGridweb;
